import {useQuery} from 'react-query'
import {
  api,
  queryClient,
  useMutationQuery,
} from 'base'
import {showSuccessNotification} from 'common/helpers'

export const useGetProjectJournal = (projectUuid: string, enabled?: boolean) => {
  return useQuery(
    ['project-journal', projectUuid],
    async () => {
      const {data} = await api.get('/journalTransaction/list', {
        params: {
          project: projectUuid,
        },
      })
      return data.data
    },
    {enabled}
  )
}

export const useGetJournalRequest = (uuid: string, enabled?: boolean) => {
  return useQuery(
    ['journal-request-details', uuid],
    async () => {
      const {data} = await api.get(`/journalTransaction/${uuid}`, {
        params: {
          include: 'statuses',
        },
      })
      return data.data
    },
    {enabled}
  )
}

export const useCreateJournal = (
  onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['create-new-journal'],
    async (payload) => {
      const {data} = await api.post('/journalTransaction/new', payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation journal item has been created.')
        onClose()
      },
    }
  )
}

export const useUpdateJournal = (
  journalUuid: string,
  onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['update-journal', journalUuid],
    async (payload) => {
      const {data} = await api.post(`/journalTransaction/${journalUuid}`, payload)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        queryClient.invalidateQueries('journal-request-details')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation journal item has been updated.')
        onClose()
      },
    }
  )
}
export const useDeleteJournal = (
  // onClose: () => void,
) => {
  return useMutationQuery<any, any, any>(
    ['delete-journal'],
    async (payload) => {
      const {data} = await api.delete(`/journalTransaction/${payload.uuid}`)
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('variation-schedule-info')
        // setForecastCreatedProjects(projectUuid)
        // queryClient.invalidateQueries('forecast')
        showSuccessNotification('Variation journal item has been deleted.')
        // onClose()
      },
    }
  )
}
